/**
 * Right-sized images for GRIDS (Pack C4, Fable F8).
 *
 * Gallery, portfolio and homepage tiles used the ORIGINAL upload as their
 * <img src> — a 60-photo gallery downloaded 60 full-size files just to show
 * thumbnails. sizedImage() asks Cloudinary for a width-limited copy in the best
 * format and quality for the browser (f_auto,q_auto,c_limit,w_N). c_limit never
 * upscales. Only for tiles: the full-screen viewer and downloads keep the
 * original, so agents see no quality change where it matters.
 *
 * Anything that is not a plain Cloudinary image-upload URL, or already carries
 * a transformation, is returned untouched. Pair with onError={fallbackToOriginal}
 * so a tile can never be worse off than before.
 */
const CLD = /^(https?:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/;
// A Cloudinary transformation segment: comma-joined "key_value" parts with
// 1-2 letter keys (w_800, c_fill, f_auto, q_auto:good). "v1712…" is a version.
const TRANSFORM = /^[a-z]{1,2}_[^/,]+(,[a-z]{1,2}_[^/,]+)*$/;

export function sizedImage(url, width) {
  if (typeof url !== 'string' || !(Number(width) > 0)) return url;
  const m = url.match(CLD);
  if (!m) return url;
  const first = m[2].split('/')[0];
  if (TRANSFORM.test(first)) return url;
  return `${m[1]}f_auto,q_auto,c_limit,w_${Math.round(width)}/${m[2]}`;
}

/** onError handler: swap back to the original URL once. */
export function fallbackToOriginal(original) {
  return (e) => {
    const img = e && e.currentTarget;
    if (img && original && img.getAttribute('src') !== original) img.setAttribute('src', original);
  };
}
